export default "__VITE_ASSET__Demy$qNs__"